import { DefaultSeoProps } from "next-seo"

const config: DefaultSeoProps = {
  description:
    "An AI-driven market intelligence platform tailored for asset and wealth management professionals. Access personalized analytics and actionable insights for better decision-making and tracking vital industry trends.",
  title: undefined,
  titleTemplate: "Grafiniti | %s",
  defaultTitle: "Grafiniti",
  openGraph: {
    type: "website",
    locale: "en_IE",
    url: process.env.NEXT_PUBLIC_API_BASE_URL,
    siteName: "Grafiniti",
    images: [
      {
        url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/opengraph-image.png`,
        width: 200,
        height: 200,
        alt: "Grafiniti Logo",
        type: "image/png",
      },
    ],
  },
  twitter: {
    handle: "@handle",
    site: "@site",
    cardType: "summary_large_image",
  },
  robotsProps: {
    notranslate: true,
    maxSnippet: 20,
    noarchive: true,
    maxImagePreview: "standard",
  },
}

export default config
